export default __webpack_public_path__ + "static/media/Mathematics_practiceevent.0f7304f2.png";